var React = require('react');

function CaretInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.90121 5.9995L10 4.9212L5.00434 0L0 4.9207L1.09778 6L5.00333 2.15972L8.90121 5.9995Z","fill":"black"}));
}

CaretInline.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = CaretInline;

CaretInline.default = CaretInline;
